export default __webpack_public_path__ + "static/media/longchamp19.59a005e0.jpg";